import dataModel from '../../models/DataModel.js';
import companiesService from '../../services/companiesService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export default class CompaniesCollection extends AOCollection {
  constructor(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor) {
    super({
      name: ReduxConstants.COMPANIES,
      collectionType: ReduxConstants.COMPANY,
      perPage, 
      searchString, 
      userId,
      companyId, 
      subKey,
      filter,
      recordDescriptor,
    });
  }

  static build(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor) {
    const collection = new CompaniesCollection(perPage, searchString, userId, companyId, subKey, filter, recordDescriptor);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collection._recordState = '';
      dataModel.collectionsDAO.setCollection(collection.getKey(), collection.getData(), collection.getCollectionType(), recordDescriptor);
    }
    else {
      collection._filter = collectionData._filter;
      collection.ids = collectionData.ids;
      collection.page = collectionData.page;
      collection.perPage = collectionData.perPage;
      collection.meta = collectionData.meta;
      collection.recordDescriptor = collectionData.recordDescriptor ? collectionData.recordDescriptor : recordDescriptor;
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection);
    });
  }

  async fetchNext(pageOverride, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        if (pageOverride) {
          this.page = pageOverride;
        }
        else this.page++;

        let serviceCall = companiesService.getCompanies.bind(this, this._searchString, this.page, this.perPage, null, options);
      
        let newCollection = await this._fetchData(serviceCall, options, true, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        newCollection.totalCompanies = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  } 

  async fetchCurrent(unmanned, options = {}, prefetchCallback, companyOverride) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = companiesService.getCompanies.bind(this, options, companyOverride, this._searchString);
        let newCollection = await this._fetchData(serviceCall, options, null, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }
        newCollection.totalCompanies = newCollection.meta ? newCollection.meta.total_records : 0;
        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/CompaniesCollection.js